export enum componentsTypes {
    LIST_FIELDS_SCP_BENEFITS = '_onboardinglink_componente_listFields_scp_beneficio',
    LIST_FIELDS_TITLE = '_onboardingpf_componente_listFields_title',
    LIST_FIELDS_SUBTITLE = '_onboardingpf_componente_listFields_subtitle',
    LIST_FIELDS_ICON = '_onboardingpf_componente_listFields_icon',
    LIST_FIELDS_DESCRIPTION = '_onboardingpf_componente_listFields_description',
    LIST_FIELDS_VALUE = '_onboardingpf_componente_listFields_value',
    LIST_FIELDS_LABEL = '_onboardingpf_componente_listFields_label',
    LIST_FIELDS_INFO = '_onboardingpf_componente_listFields_info',
    LIST_FIELDS_CODE = '_onboardingpf_componente_listFields_code',
    LIST_FIELDS_CREDIT = '_onboardingpf_componente_listFields_credit',
    LIST_FIELDS_DEBIT = '_onboardingpf_componente_listFields_debit',
    LIST_FIELDS_GRACE_PERIOD = '_onboardingpf_componente_listFields_gracePeriod',
    LIST_FIELDS_FRANCHISE = '_onboardingpf_componente_listFields_franchise',
    LIST_FIELDS_PRICE = '_onboardingpf_componente_listields_price',
    LIST_FIELDS_COVERAGE = '_onboardingpf_componente_listFields_coverage',
  }
